import React from 'react';
import { NavLink } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hooks';
import {
  ClientIcon,
  ContractIcon,
  SearchIcon,
  SettingsIcon,
  UserIcon,
  DownloadIcon,
} from 'icons';
import {
  DEALER_CONFIG_RESULT_ROUTE,
  DEALER_INFORMATION_ROUTE,
  DEALER_SETTINGS_ROUTE,
  DEALER_TICKETS_ROUTE,
  CUSTOMER_INFORMATION_ROUTE,
  DEALER_LICENSE_CONTENT_ROUTE,
} from 'constants/routes';

export const DealerSidebar: React.FC = () => {
  const { t } = useTranslation();
  const { dealer } = useAppSelector((state) => state.auth.data);

  return (
    <aside className="sidebar d-md-flex">
      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="dealer-info-tooltip" {...props}>
            {t('dealerManagement.dealerInformation')}
          </Tooltip>
        )}
      >
        <NavLink to={DEALER_INFORMATION_ROUTE} className="sidebar-link">
          <ClientIcon />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="dealer-tickets-tooltip" {...props}>
            {t('dealerManagement.dealerTickets')}
          </Tooltip>
        )}
      >
        <NavLink to={DEALER_TICKETS_ROUTE} className="sidebar-link">
          <ContractIcon />
        </NavLink>
      </OverlayTrigger>

      {dealer?.permissions?.ownConfigurationsAllowed && (
        <OverlayTrigger
          placement="right"
          delay={{ show: 100, hide: 100 }}
          overlay={(props) => (
            <Tooltip id="dealer-config-tooltip" {...props}>
              {t('dealerManagement.dealerConfigTestView')}
            </Tooltip>
          )}
        >
          <NavLink to={DEALER_CONFIG_RESULT_ROUTE} className="sidebar-link">
            <SearchIcon />
          </NavLink>
        </OverlayTrigger>
      )}

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="customer-info-tooltip" {...props}>
            {t('dealerManagement.customerInformation')}
          </Tooltip>
        )}
      >
        <NavLink to={CUSTOMER_INFORMATION_ROUTE} className="sidebar-link">
          <UserIcon color="#00000" />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="license-content-tooltip" {...props}>
            {t('dealerManagement.licenseContent')}
          </Tooltip>
        )}
      >
        <NavLink to={DEALER_LICENSE_CONTENT_ROUTE} className="sidebar-link">
          <DownloadIcon color="#393F4B" />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="dealer-settings-tooltip" {...props}>
            {t('dealerManagement.dealerSettings')}
          </Tooltip>
        )}
      >
        <NavLink to={DEALER_SETTINGS_ROUTE} className="sidebar-link">
          <SettingsIcon />
        </NavLink>
      </OverlayTrigger>
    </aside>
  );
};
